import {Component, Vue} from 'vue-facing-decorator';
import ax from '@/utils/axios_non';
import Loading from 'vue-loading-overlay';
import {reactive} from 'vue'

import {authLogin} from '@/utils/auth';

@Component({
    components: {
        Loading
    }
})
export default class Login extends Vue {
    private appElement: HTMLElement | null = null;
    public isLoading = false;
    public windowHeight = window.innerHeight;

    public user = reactive({
        username: '',
        password: ''
    });

    public isInvalid = reactive({
        username: {
            status: false,
            msg: ''
        },
        password: {
            status: false,
            msg: ''
        }
    });

    public async mounted() {
        this.isLoading = true;

        try {
            const response = await ax.get('admin/config/base/get_base_config');
            if (response.data.status) {
                //console.log(response.data.data)
                this.$store.commit('baseData/setBaseData', response.data.data.profile);
                this.$store.dispatch('baseConfig/setConfig', response.data.data.setting);
                this.$store.dispatch('baseConfig/setDefault', response.data.data.default);
            }
            this.isLoading = false;
        } catch (error) {
            //this.toast.error('terjadi kesalahan saat mengambil data!!');
            this.isLoading = false;
        }

        //set backround
        if (this.app_base_data.img_background != '') {
            document.body.style.backgroundImage = `url('${this.app_base_data.img_background}')`;
        }
    }

    public unmounted(): void {
        if (this.app_base_data.img_background != '') {
            document.body.style.backgroundImage = "";
        }
    }

    public async submitForm(): Promise<void> {
        this.isInvalid = {
            username: {
                status: false,
                msg: ''
            },
            password: {
                status: false,
                msg: ''
            }
        };

        //cek input terisi-----------------------------------------------
        if (this.user.username == '') {
            this.isInvalid.username.status = true;
            this.isInvalid.username.msg = 'Username / Email Wajib Diisi!!';
        }
        if (this.user.password == '') {
            this.isInvalid.password.status = true;
            this.isInvalid.password.msg = 'Password Wajib Diisi!!';
        }
        //jika user dan pass kosong----------------------------------------------
        if (this.user.username == '' || this.user.password == '') {
            const isInvalid : any = this.isInvalid;
            for (const field in isInvalid) {
                if (isInvalid[field].status) {
                    this.$toast.add(
                        { 
                            severity: 'error', 
                            summary: 'Form Salah',
                            detail: isInvalid[field].msg, 
                            life: 3000 
                        });
                }
            }
        }
        //jika user dan pass terisi----------------------------------------------
        else {
            this.isLoading = true;
            //-------------------------------------------------------------------
            await authLogin(this.user.username, this.user.password)
                .then((res : any) => {
                    this.isLoading = false;
                    this.$toast.add({ severity: 'success',  summary: 'login', detail: res.message, life: 3000 });
                    if (res.status) {
                        this.$store.dispatch('auth/setAuthentication', res.data.token);
                        this.$store.dispatch('user/setUser', res.data.user);
                        this.$store.dispatch('ui/setLayoutSidebarMode', res.data.user.ui.layout_sidebar_mode);
                        this.$store.dispatch('ui/onChangeDarkTheme', res.data.user.ui.is_dark);
                        this.$router.push('/home');
                    }else{
                        this.$toast.add({ severity: 'warn',  summary: 'login', detail: res.message, life: 3000 });
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    //console.log(error);
                    this.$toast.add({ severity: 'error',  summary: 'login', detail: error.message, life: 3000 });
                    if(error.response){
                        this.$toast.add({ severity: 'error',  summary: 'login', detail: error.response.data.message, life: 3000 });
                        if(error.response.data.errors){
                            if (error.response.data.errors.length > 0) {
                                error.response.data.errors.forEach((item :any) => {
                                    this.$toast.add({ severity: 'error',  summary: 'login', detail: item, life: 3000 });
                                })
                            }
                        }
                    }
                });
            //-------------------------------------------------------------------
            
        }
        //-----------------------------------------------------------------------
    }

    get app_base_data(): any {
        return this.$store.state.baseData;
    }

    get app_base_config(): any {
        return this.$store.getters['baseConfig/getConfig']
      }

    get gradientStyle() {
        return `linear-gradient(${this.app_base_data.main_theme_color}, ${this.app_base_data.second_theme_color})`;
    }

    get mainColor() {
        return `${this.app_base_data.main_theme_color}`;
    }
}
